// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"341":"453b520e","450":"c9dff56f","453":"f5117e8e"}[chunkId] + ".chunk.js";
};